import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import * as styles from './StatusBar.css';
import { clsx } from 'clsx';

type Message = {
  message: string;
  color: MessageColor;
};

enum MessageColor {
  RED = 'red',
  GREEN = 'green',
}

type Subscriber = (message: string, color: MessageColor) => void;

let subscriptions: Subscriber[] = [];
function subscribe(callback: Subscriber) {
  subscriptions.push(callback);
  //console.log('[StatusBar] Component subscribed.');
}

function unsubscribe(callback: Subscriber) {
  subscriptions = _.without(subscriptions, callback);
  //console.log('[StatusBar] Component unsubscribed.');
}

function sendErrorMessage(message: string) {
  toast.error(message);
}

const StatusBar = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const push = useCallback((message, color) => {
    setMessages((prev) => [...prev, { message, color }]);
  }, []);

  useEffect(() => {
    subscribe(push);
    return () => {
      unsubscribe(push);
    };
  }, [push]);

  const dismissLastMessage = () => {
    setMessages((prev) => prev.slice(0, -1));
  };

  const dismissAllMessages = () => {
    setMessages([]);
  };

  const lastMessage: Message | undefined = messages[messages.length - 1];
  const statusBarClass = clsx(
    styles.statusBar,
    messages && messages.length > 0 && styles.open,
  );

  return (
    <div className={statusBarClass}>
      <p className={styles.message}>{lastMessage?.message}</p>
      {messages.length > 1 && (
        <a onClick={dismissAllMessages} className={styles.dismissButton}>
          Dismiss all messages ({messages.length})
          <span className={styles.removeIcon}></span>
        </a>
      )}
      <a onClick={dismissLastMessage} className={styles.dismissButton}>
        Dismiss <span className={styles.removeIcon}></span>
      </a>
    </div>
  );
};

export default { Component: StatusBar, sendErrorMessage: sendErrorMessage };
